// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1eyDf","noInteraction":"EventWrapper_noInteraction__33uQ5","pointerPassthrough":"EventWrapper_pointerPassthrough__3v37o"};